export function IsLocation(b) {
    if (typeof b !== "object" || b === null)
        return false;
    return b.lat !== undefined && b.lon !== undefined;
}
export function IsEnvelope(b) {
    if (typeof b !== "object" || b === null)
        return false;
    return b.nw !== undefined && b.sw !== undefined && b.ne !== undefined && b.nw !== undefined;
}
export function IsGeoBounded(b) {
    if (typeof b !== "object" || b === null)
        return false;
    return IsEnvelope(b.geoBounds);
}
//# sourceMappingURL=geography.interfaces.js.map